import React from 'react';
import { Navigate, Link, useLocation } from 'react-router-dom';
import { LayoutDashboard, Settings, Inbox, Users, Home, Loader2, FileText, Image as ImageIcon, Package } from 'lucide-react';
import { useAuth } from '../../context/AuthContext';

const navItems = [
  { to: '/admin', label: 'Dashboard', icon: LayoutDashboard, end: true },
  { to: '/admin/packages', label: 'Parcel Requests', icon: Package },
  { to: '/admin/site', label: 'Site Settings', icon: Settings },
  { to: '/admin/content', label: 'Content Manager', icon: FileText },
  { to: '/admin/media', label: 'Photos & Media', icon: ImageIcon },
  { to: '/admin/submissions', label: 'Submissions', icon: Inbox },
  { to: '/admin/users', label: 'Users', icon: Users },
];

const AdminLayout = ({ children }) => {
  const { user, loading } = useAuth();
  const loc = useLocation();

  if (loading) return <div className="min-h-[60vh] flex items-center justify-center"><Loader2 className="w-6 h-6 animate-spin text-[#c8102e]" /></div>;
  if (!user) return <Navigate to="/login" state={{ from: loc.pathname }} replace />;
  if (!user.is_admin) return <Navigate to="/account" replace />;

  return (
    <div className="min-h-[80vh] bg-neutral-50">
      <div className="max-w-7xl mx-auto px-6 py-10 grid grid-cols-1 lg:grid-cols-[240px_1fr] gap-8">
        <aside>
          <div className="bg-black text-white p-6 mb-4">
            <div className="flex items-center gap-3 mb-2"><span className="h-px w-8 bg-[#c8102e]" /><span className="eyebrow text-white">Admin</span></div>
            <h2 className="font-serif-display text-xl font-bold">Control Center</h2>
            <p className="text-xs text-white/60 mt-1">Signed in as {user.name}</p>
          </div>
          <nav className="space-y-1">
            {navItems.map((n) => {
              const active = n.end ? loc.pathname === n.to : loc.pathname.startsWith(n.to);
              const Icon = n.icon;
              return (
                <Link key={n.to} to={n.to} className={`flex items-center gap-3 px-4 py-3 text-sm font-semibold transition-colors ${active ? 'bg-[#c8102e] text-white' : 'bg-white text-black hover:bg-neutral-100'}`}>
                  <Icon className="w-4 h-4" /> {n.label}
                </Link>
              );
            })}
            <Link to="/" className="flex items-center gap-3 px-4 py-3 text-sm font-semibold text-neutral-500 hover:text-black mt-4 border-t border-neutral-200 pt-4">
              <Home className="w-4 h-4" /> Back to site
            </Link>
          </nav>
        </aside>
        <main>{children}</main>
      </div>
    </div>
  );
};

export default AdminLayout;
